import { useEffect, useState, useRef } from "react";

import { useAsyncConfig } from "../../../../components/organisms/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import { setSort } from "../../../../redux/reducers/filter";
import { useGetAuditLogs } from "../../../../redux/reduxQuery/auditApi";

export const useGetData = (initialQs = "") => {
  const [dataToFetch, setDataToFetch] = useState(initialQs);
  const dispatch = useAppDispatch();
  const prevSortRef = useRef<string | null>(null);

  useEffect(() => {
    setDataToFetch((prev) => (prev === initialQs ? prev : initialQs));
  }, [initialQs]);
  const pageSize = useAppSelector(
    (state) => state.filter?.auditLogControl?.pageSize
  );
  const searchParam = useAppSelector(
    (state) => state.filter?.auditLogControl?.searchParam
  );
  const sort = useAppSelector((state) => state.filter?.auditLogControl?.sort);

  const getData = useGetAuditLogs(dataToFetch);
  let search: string | undefined = "";
  if (searchParam === undefined || typeof searchParam === "string") {
    search = searchParam;
  } else {
    search = "";
  }

  let [config, refetch] = useAsyncConfig(
    getData,
    Number(pageSize ?? 50),
    search
  );

  const isFirstFetch = useRef(true);
  useEffect(() => {
    // Skip first render - useAsyncConfig already fetches on mount
    if (isFirstFetch.current) {
      isFirstFetch.current = false;
      return;
    }
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToFetch]);

  // if there's a sort order in the redux store, let's use it
  // otherwise, let's default to createdAt descending
  useEffect(() => {
    if ((sort as any)?.length > 0) {
      config.asyncConfig.onSortingChange(sort as any);
    } else {
      config.asyncConfig.onSortingChange([{ id: "createdAt", desc: true }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync sort changes to Redux for persistence
  const currentSort = config?.asyncConfig?.sort;
  useEffect(() => {
    const sortStr = JSON.stringify(currentSort || []);
    if (prevSortRef.current !== sortStr) {
      prevSortRef.current = sortStr;
      dispatch(
        setSort({
          auditLogControl: {
            sort: currentSort && currentSort.length > 0 ? currentSort : null,
          },
        })
      );
    }
  }, [currentSort, dispatch]);

  return {
    config,
    refetch,
    dataToFetch,
    setDataToFetch,
  };
};
